import React from 'react';
import { EssentialsProvider } from '@wix/fe-essentials/react';
export const RootEssentialsWrapperProvider = ({ essentials, children, }) => {
    return (React.createElement(EssentialsProvider, { essentials: essentials }, children));
};
//# sourceMappingURL=RootEssentialsWrapperProvider.js.map